export enum TimelineCapShape {
  None = 'none',
  Triangle = 'triangle',
  Rect = 'rect',
}
